'use client'
import React from 'react'
import Link from 'next/link'
import Image from 'next/image'
import { sendGAEvent } from '@next/third-parties/google'

const BlogFeaturedCard = ({ blog, dictionary }) => {
  return (
        <div className='w-full flex justify-between items-start gap-2'>
            <div className='relative w-[120px] flex-shrink-0 aspect-[4/3] rounded-md  overflow-hidden'>
                <Image
                    className='object-cover'
                    src={blog?.cloudThumbnail ? blog.cloudThumbnail : '/images/test.jpg'}
                    fill={true}
                />
            </div>
            <div className='flex flex-col w-full'>
            <Link 
                onClick={() => sendGAEvent({ 
                    event: "select_content",
                    blog_id: blog._id.toString(),
                    blog_name: blog.title,
                })} 
                className='cursor-pointer hover:underline hover:underline-offset-4' 
                href={`/blogs/${blog.slug}`}
            >
                <p className='text-maincolor font-semibold line-clamp-2'>{blog.title}</p>
            </Link>
            <p className='text-secondary line-clamp-2 text-sm'>{blog.excerpt}</p>
            </div>
        </div>
  )
}

export default BlogFeaturedCard